import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import * as routes from 'core/routing/constants'
import { Wizard } from 'react-albus'

const RoutedWizard = ({ path, children }) => (
  <Route
    render={({ history }) => {
      if (!localStorage.getItem('config')) return <Redirect to={routes.ERROR} />

      return (
        <Wizard history={history} basename={path}>
          {children}
        </Wizard>
      )
    }}
  />
)
RoutedWizard.defaultProps = {}
RoutedWizard.propTypes = {
  path: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired
}

export default RoutedWizard
